import { render, staticRenderFns } from "./CarKindForm.vue?vue&type=template&id=4b0e09dc"
import script from "./CarKindForm.vue?vue&type=script&lang=js"
export * from "./CarKindForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0e09dc')) {
      api.createRecord('4b0e09dc', component.options)
    } else {
      api.reload('4b0e09dc', component.options)
    }
    module.hot.accept("./CarKindForm.vue?vue&type=template&id=4b0e09dc", function () {
      api.rerender('4b0e09dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/treetable/CarKindForm.vue"
export default component.exports